export default __webpack_public_path__ + "static/media/loginBackground.3dc4c971.svg";